@let
formLabelValue = (formControlField?.value || formControlField?.value === 0) && size !== 'small' && label ? label : '';
@let inputLabelValue = (inputValue || inputValue === 0) && size !== 'small' && label ? label : '';

<div [ngClass]="['mp-input', size, customClasses]"
  [class.error]="isInvalidInput"
  [class.outlined]="outlined"
  [class.disabled]="disabled"
  [class.readonly]="isReadOnly"
  [class.with-icon]="faIcon">
  <ng-container *ngIf="formControlField">
    <i *ngIf="faIcon" class="mp-input-icon {{faIcon}}" [class.disabled]="iconDisabled || disabled"
      [class.without-value]="!formControlField?.value && formControlField.value !== 0"
      (click)="iconClick()" [class.clickable]="!!iconClick && !iconDisabled"></i>
    <label class="mp-input-label">
      {{ formLabelValue | translate }}
      <input #formControlInputField
        tabindex="0"
        autocomplete="off"
        [step]="step"
        [pattern]="pattern"
        (blur)="onBlur(formControlInputField)"
        [readonly]="disabled || isReadOnly"
        class="mp-input-field"
        [class.with-label]="label"
        [mpTooltip]="formControlField?.value"
        [mpTooltipDisabled]="disabled || !isEllipsisActive()"
        [class.without-value]="!formControlField?.value && formControlField?.value !== 0"
        [placeholder]="label| translate"
        [formControl]="formControlField"
        [type]="type"/>
    </label>
  </ng-container>
  <ng-container *ngIf="!formControlField">
    <i *ngIf="faIcon" class="mp-input-icon {{faIcon}}" [class.disabled]="iconDisabled"
      [class.without-value]="!inputValue && inputValue !== 0"
      (click)="iconClick()" [class.clickable]="!!iconClick && !iconDisabled"></i>
    <label class="mp-input-label">
      {{ inputLabelValue | translate }}
      <input #valueInputField
        class="mp-input-field"
        tabindex="0"
        autocomplete="off"
        [step]="step"
        [pattern]="pattern"
        (blur)="onBlur(valueInputField)"
        [readonly]="disabled || isReadOnly"
        [class.with-label]="label"
        [class.without-value]="!inputValue && inputValue !== 0"
        [placeholder]="label | translate"
        [mpTooltip]="inputValue?.toString()"
        [mpTooltipDisabled]="disabled || !isEllipsisActive()"
        [(ngModel)]="inputValue"
        [ngModelOptions]="{standalone: true}"
        (ngModelChange)="onValueChanged()"
        [type]="type"/>
    </label>
  </ng-container>
  <span class="reset-value" tabindex="0" *ngIf="!isReadOnly && canResetValue()"
    (click)="resetValue($event)" (keydown.enter)="resetValue($event)">
    <i class="far fa-times-circle value-remove-icon"></i>
  </span>
</div>
<div *ngIf="isInvalidInput" class="mp-input-invalid">
  {{ invalidInputErrorMsg() | translate }}
</div>



